import { useNotification } from "@context/NotificationContext";
import { renewNOC } from "@services/portServicesApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";
import { t } from "i18next";

const LANG_BASE = "vessel-call.port-services";
const service = "bff-vessel-call";
const RENEW_NOC_TRANSACTION_CONTEXT = {
  module: "vessel_call",
  screen: "Port Services",
  action: "renew_noc",
  entityType: "port_service",
};

interface UseRenewNOCProps {
  portServiceId: string;
  setShouldRefetch?: (value: boolean) => void;
}

export const useRenewNOC = ({ portServiceId, setShouldRefetch }: UseRenewNOCProps) => {
  const { notify } = useNotification();

  const { mutate, isPending } = useMutation({
    mutationFn: () =>
      runTransaction(
        {
          ...RENEW_NOC_TRANSACTION_CONTEXT,
          entityId: portServiceId,
        },
        (transactionId) =>
          renewNOC(service, portServiceId, ...(transactionId ? [transactionId] : [])),
      ),
    onSuccess: () => {
      setShouldRefetch?.(true);
      notify({
        title: t(`${LANG_BASE}.notifications.noc-renew-success-title`),
        description: t(`${LANG_BASE}.notifications.noc-renew-success-description`),
        type: "success",
      });
    },
    onError: () => {
      notify({
        title: t(`${LANG_BASE}.notifications.noc-renew-error-title`),
        description: t(`${LANG_BASE}.notifications.noc-renew-error-description`),
        type: "error",
      });
    },
  });

  return { onRenewNOC: mutate, isRenewing: isPending };
};
